module.exports = __webpack_public_path__ + "img/myself.486e330a.png";